/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import firebase from 'firebase/app'
// import 'firebase/auth'
import router from "@/router";
import api, { updateBaseURL } from "@/axios.js";
import Vue from "vue";
import axios from "axios";

// Helper function to fetch dynamic URL from urlmap
const fetchDynamicURL = async (username) => {
  try {
    const urlmapEndpoint = process.env.VUE_APP_URLMAP_API + "api/v1/url";
    if (!urlmapEndpoint) {
      console.warn("VUE_APP_URLMAP_API not configured");
      return null;
    }
    const isEmail = username.includes("@");
    const paramKey = isEmail ? "email" : "username";

    const response = await axios.get(`${urlmapEndpoint}?${paramKey}=${username}`);
    
    if (response.data && response.data.url) {
      return response.data.url;
    }
    return null;
  } catch (error) {
    console.error("Error fetching dynamic URL:", error);
    return null;
  }
};

export default {
  loginAttempt({ dispatch }, payload) {
    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation,
    };
    dispatch("login", newPayload);
  },
  async login({ state }, payload) {
    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation();
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      return false;
    }

    try {
      // First, fetch dynamic URL based on username/email
      const username = payload.userDetails.email; // Use full email as username
      const dynamicURL = await fetchDynamicURL(username);
      
      if (dynamicURL) {
        // Store the dynamic URL in cookie
        Vue.$cookies.set("dynamic_base_url", dynamicURL, "7d");
        // Update axios baseURL
        updateBaseURL(`https://${dynamicURL}/`);
      } else {
        // If URL mapping failed, stop login process and show error
        if (payload.closeAnimation) payload.closeAnimation();
        payload.notify({
          time: 3500,
          title: "Error",
          text: "Failed to fetch URL configuration. Please try again.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        return false;
      }

      // Proceed with login
      api
        .post("/api/account/v1/authentication", {
          authentication_id: payload.userDetails.email,
          authentication_type: "email",
          password: payload.userDetails.password,
        })
        .then(
          (result) => {
            if (payload.closeAnimation) {
              setTimeout(() => {
                payload.closeAnimation();
              }, 2000);
            }
            if (result.code == 200) {
              Vue.$cookies.config("7d", "/", "", false);
              Vue.$cookies.set("token", result.data.token);
              payload.notify({
                time: 3500,
                color: "success",
                title: "Login Berhasil",
                text: "",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-check",
              });
              router.push("/");
            } else {
              payload.notify({
                time: 3500,
                title: "Error",
                text: result.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            }
            return false;
          },
          (error) => {
            // Close animation if passed as payload
            if (payload.closeAnimation) payload.closeAnimation();
            payload.notify({
              time: 2500,
              title: "Error",
              text: error.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
            return false;
          }
        );
    } catch (error) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation();
      payload.notify({
        time: 2500,
        title: "Error",
        text: "Failed to fetch URL configuration. Please try again.",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "top-right",
      });
      return false;
    }
    // Try to sigin
  },
  forgotPasswordAttempt({ dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation,
    };
    dispatch("forgotPassword", newPayload);
  },
  forgotPassword({ state }, payload) {
    if (state.isUserLoggedIn()) {
      if (payload.closeAnimation) payload.closeAnimation();
      payload.notify({
        title: "Forgot Password Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });

      return false;
    }

    api
      .post("/api/account/v1/auth/reset-password", {
        email: payload.userDetails.email,
        host: window.location.host,
      })
      .then((res) => {
        if (payload.closeAnimation) {
          setTimeout(() => {
            payload.closeAnimation();
          }, 2000);
          if (res.code == 200) {
            payload.notify({
              time: 3500,
              color: "success",
              title: "Request Reset Password Successfully",
              text: "",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            router.push("/pages/login");
          } else {
            payload.notify({
              time: 3500,
              title: "Error",
              text: res.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
          return false;
        }
      })
      .catch((err) => {
        if (payload.closeAnimation) payload.closeAnimation();
        payload.notify({
          time: 2500,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        return false;
      });
  },
  // registerUser({dispatch}, payload) {

  // },
  updateDataUser({ commit }, payload) {
    commit("UPDATE_USER", payload);
  },
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName,
      })
      .then(() => {
        // If username update is success
        // update in localstorage
        let newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.displayName;
        commit("UPDATE_USER_INFO", newUserData, { root: true });

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || "/");
        }
      })
      .catch((err) => {
        payload.notify({
          time: 8800,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });
  },
  // fetchAccessToken() {
  //   return new Promise((resolve) => {
  //     // jwt.refreshToken().then(response => { resolve(response) })
  //   })
  // }

  fetchCallback({ state }, { code, sourceAppId }) {
    api
      .post("/api/account/v1/auth/callback", {
        code: code,
        source_app_id: sourceAppId,
      })
      .then(
        (result) => {
          if (result.code == 200) {
            Vue.$cookies.config("7d", "/", "", false);
            Vue.$cookies.set("token", result.data.token);
            router.push("/");
          } else {
            // Vue.$cookies.set("token", null);
            // router.push("/");
          }
          return false;
        },
        (error) => {
          console.log(error);
          router.push("/");
          return false;
        }
      );
  },
};
